import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'store';

// ==============================|| AUTH GUARD ||============================== //

const AuthGuard = ({ children }) => {
  const { isLoggedIn } = useSelector(({ auth }) => auth);
  const location = useLocation();

  if (isLoggedIn) {
    return children;
  }

  return <Navigate to="/login" replace state={{ from: location.pathname }} />;
};

AuthGuard.propTypes = {
  children: PropTypes.node
};

export default AuthGuard;
